module.exports = __webpack_public_path__ + "media/application/images/2018/2018-rating-lock-grey-863d3b7b6750e0bc514fd31e084acf7c.svg";